<template>
    <div>
        <feathers-vuex-find service="service-lists" :query="{}" watch="query">
            <v-card slot-scope="{ items: desserts, isFindPending }">
                <v-card-title>
                    Services Control Access
                    <v-spacer></v-spacer>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :loading="isFindPending" :items="desserts" :search="search">
                    <template v-slot:item.id="{ item }">
                        <b>{{ item.id }}</b>
                    </template>
                    <template v-slot:item.methods="{ item }">
                        <v-chip x-small v-for="(method, index) in item.methods" class="ma-2" color="cyan" text-color="white" :key="index">{{ method }}</v-chip>
                        <v-chip x-small v-if="item.methods.length === 0" class="ma-2" color="red" text-color="white">Not Accessible</v-chip>
                        
                    </template>
                    <template v-slot:item.authenticate="{ item }">
                        <v-chip x-small v-for="(method, index) in item.rules.authenticate" class="ma-2" color="secondary" text-color="white" :key="index">{{ method }}</v-chip>
                        <v-chip x-small v-if="item.rules.authenticate.length === 0" class="ma-2" color="primary" text-color="white">No Authentication Required</v-chip>
                    </template>
                    <template v-slot:item.owner="{ item }">
                        <v-chip x-small class="ma-2" :color="item.rules.owner ? `green` : `red`" text-color="white">{{ item.rules.owner ? item.rules.ownerField : 'Disabled' }}</v-chip>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-dialog v-model="item.dialog" width="700" persistent>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn fab x-small v-bind="attrs" v-on="on" color="primary">
                                    <v-icon x-small>fas fa-edit</v-icon>
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    Update Services Controls
                                </v-card-title>

                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="9">
                                                <v-select v-model="item.methods" :items="['get', 'find', 'create', 'patch', 'update', 'remove']" chips label="Methods" multiple :disabled="serviceMS(item).default || loadingForm"></v-select>
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                                <v-checkbox v-model="serviceMS(item).default" label="Use Default" :disabled="loadingForm"></v-checkbox>
                                            </v-col>

                                            <v-col cols="12" sm="9">
                                                <v-select v-model="item.rules.authenticate" :items="['get', 'find', 'create', 'patch', 'update', 'remove']" chips label="Authentication Required" multiple :disabled="serviceAS(item).default || loadingForm"></v-select>
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                                <v-checkbox v-model="serviceAS(item).default" label="Use Default" :disabled="loadingForm"></v-checkbox>
                                            </v-col>

                                            <v-col cols="12" sm="4">
                                                <v-checkbox v-model="item.rules.owner" label="Set Owner Field" :disabled="loadingForm"></v-checkbox>
                                            </v-col>
                                            <feathers-vuex-get v-if="item.rules.owner" service="model-props" :id="item.id">
                                                <v-col cols="12" sm="8" slot-scope="{ item: Attributes, isGetPending }">
                                                    <v-select v-if="!isGetPending" v-model="item.rules.ownerField" :items="Attributes.col" label="Target Attribute" :disabled="loadingForm"></v-select>
                                                    <v-progress-circular v-else indeterminate color="red"></v-progress-circular>
                                                </v-col>
                                            </feathers-vuex-get>
                                        </v-row>
                                    </v-container>
                                </v-card-text>

                                <v-divider></v-divider>

                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn v-if="!loadingForm" small color="red" text @click="item.dialog = false">Cancel</v-btn>
                                    <v-btn small color="primary" text @click="updateService(item)" :loading="loadingForm">Save</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </template>
                </v-data-table>
            </v-card>
        </feathers-vuex-find>
        <v-snackbar top v-model="successMessage" color="success">
            Successfully Saved!
        </v-snackbar>
        <v-snackbar top v-model="error.show" color="red">
            {{ error.message }}
        </v-snackbar>
    </div>
</template>

<script>

export default {
    data() {
        return {
            search: '',
            headers: [
                {
                    text: 'Services',
                    align: 'start',
                    sortable: false,
                    value: 'id',
                },
                {
                    text: 'Accessable Methods',
                    align: 'end',
                    sortable: false,
                    value: 'methods'
                },
                {
                    text: 'Authentication Required',
                    align: 'end',
                    sortable: false,
                    value: 'authenticate'
                },
                {
                    text: 'Owner Only',
                    align: 'end',
                    sortable: false,
                    value: 'owner'
                },
                {
                    text: 'Actions',
                    align: 'center',
                    sortable: false,
                    value: 'actions'
                }
            ],
            successMessage: false,
            error: {
                show: false,
                message: ''
            },
            updateDialog: false,
            currentItem: {
                methods: [],
                rules: {
                    authenticate: [],
                    owner: false,
                    ownerField: 'user_id'
                },
                methodsItem() {
                    return { model: null };
                }
            },
            loadingForm: false
        }
    },
    methods: {
        serviceMS(item) {
            return {
                get default() {
                    return item.methods.indexOf('all') !== -1;
                },
                set default(value) {
                    if(value) {
                        item.methods = ['all'];
                    } else {
                        item.methods = [];
                    }
                },
                // get model() {
                //     return null;
                // },
                // set model(value) {

                // }
            };
        },
        serviceAS(item) {
            return {
                get default() {
                    return item.rules.authenticate.indexOf('all') !== -1;
                },
                set default(value) {
                    if(value) {
                        item.rules.authenticate = ['all'];
                    } else {
                        item.rules.authenticate = [];
                    }
                }
            };
        },
        async updateService(item) {
            try {
                this.loadingForm = true;
                await item.update();
                this.successMessage = true;
                item.dialog = false;
            } catch(err) {
                this.error.show = true;
                this.error.message = err.message;
            } finally {
                this.loadingForm = false;
            }
        }
    }
};
</script>